import { Card, Container, Row, Col, Form } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { chat, users, messages } from "../../Redux/messagerieReduce";
import { useTranslation } from 'react-multi-lang'
import io from 'socket.io-client';
import Select from "react-select";

function Messagerie({ obj, client }) {
  const dispatch = useDispatch();
  const t = useTranslation();
  const [activeRoom, setActiveRoom] = useState('empty');
  const [options, setOptions] = useState({});
  const [grossisteSelect, setGrossisteSelect] = useState({ value: 0, label: "Tous" });
  const [activeReceiver, setActiveReceiver] = useState('');
  const [lastActiveClass, setLastActiveClass] = useState('');
  const token = localStorage.getItem("x-access-token");
  const annee = localStorage.getItem("annee");

  useEffect(() => {
    loadMyMessages(annee, 0, client);
  }, []);

  const messageElement = (text, direction) => {
    const li = document.createElement('li');
    li.className = `${direction} clearfix`;

    const span = document.createElement('span');
    span.className = `chat-img pull-${direction}`;

    const img = document.createElement('i');
    img.className = text.roles.icon + ' img-circle ';
    span.appendChild(img);
    li.appendChild(span);

    const div = document.createElement('div');
    div.className = 'chat-body clearfix';

    const header = document.createElement('div');
    header.className = 'header';

    const strong = document.createElement('strong');
    strong.className = 'primary-font';
    strong.textContent = text.senders.nom_prenom;

    const small = document.createElement('small');
    small.className = 'pull-right text-muted';
    const icon = document.createElement('i');
    icon.className = 'fa fa-clock-o';
    small.appendChild(icon);
    small.appendChild(document.createTextNode('\u00A0'));
    const date = new Date(text.createdAt);
    const formattedDate = date.toLocaleString('fr-FR'); // "25/11/2025 11:51:55" selon le fuseau
    small.appendChild(document.createTextNode(formattedDate));
    // small.appendChild(document.createTextNode(text.createdAt));

    header.appendChild(strong);
    header.appendChild(small);
    div.appendChild(header);

    const p = document.createElement('p');
    p.textContent = text.message_body;
    div.appendChild(p);

    li.appendChild(div);
    return li;
  };

  const displayMember = (user, elementClass, annee, client) => {
    const li = document.createElement('li');
    li.id = `oneMem${user.id}`;
    if (elementClass) li.classList.add(elementClass);
    li.addEventListener('click', () => displayThread(user.id, annee, client));

    const a = document.createElement('a');
    a.href = '#';
    a.className = 'clearfix';

    const img = document.createElement('i');
    img.className = user.roles.icon + ' img-circle ';

    const friendName = document.createElement('div');
    friendName.className = 'friend-name';
    const strong = document.createElement('strong');
    strong.textContent = user.nom_prenom;
    friendName.appendChild(strong);

    const lastMessage = document.createElement('div');
    lastMessage.className = 'last-message text-muted';
    lastMessage.textContent = user.userMessages ? user.userMessages.message_body : '';

    const ledBox = document.createElement('div');
    ledBox.className = `led-box ${user.id}`;
    ledBox.style.display = user.isActive ? 'block' : 'none';
    const ledGreen = document.createElement('div');
    ledGreen.className = 'led-green';
    ledBox.appendChild(ledGreen);

    const chatAlert = document.createElement('small');
    chatAlert.className = `chat-alert chat-alert${user.id} label label-danger`;
    chatAlert.textContent = '1';
    chatAlert.style.display = 'none';

    a.appendChild(img);
    a.appendChild(friendName);
    a.appendChild(lastMessage);
    a.appendChild(ledBox);
    a.appendChild(chatAlert);
    li.appendChild(a);

    return li;
  };

  const loadMyMessages = (annee, grossiste, client) => {
    dispatch(users({ id_site: client == "/medis" ? 2 : 3 })).then((data) => {
      if (data.payload.success) {
        var memberArea = document.getElementById('member_area');
        memberArea.innerHTML = '';

        var arrayOp = [{ value: 0, label: "Tous" }];

        data.payload.message.forEach(function (user, key) {
          if (user.id_role == 6) {
            arrayOp.push({ value: user.id, label: user.nom_prenom });
          }

          if (user.id == grossiste || grossiste == 0) {
            var elementClass = '';
            if (key === 0) {
              elementClass = 'active';
              setLastActiveClass(`oneMem${user.id}`);
            }

            var memberElement = displayMember(user, elementClass, annee, client);
            memberArea.appendChild(memberElement);
          }
        });

        setOptions(arrayOp);

        if (data.payload.message.length > 0) {
          displayThread(data.payload.message[0].id, annee, client, false);
        }
      }
    });
  };

  const initiateSockets = (room, receiver_id) => {
    setActiveRoom(room);
    setActiveReceiver(receiver_id);
  };

  const createMessage = (event) => {
    if (event.which == 13) {
      dispatch(messages({
        'message_body': event.target.value,
        'receiver_id': activeReceiver,
        'conversation_id': activeRoom,
        client
      })).then((data) => {
        var member = messageElement(data.payload, "right");
        document.getElementById('messages').appendChild(member);
      });

      document.getElementById('m').value = '';
      var objDiv = document.getElementById("messages");
      objDiv.scrollTop = objDiv.scrollHeight;
    }
  };

  function generateMessageUniqueIdentifier() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 6; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }

  const displayThread = (receiver_id, annee, client, clearActive = true) => {
    if (clearActive) {
      document.querySelectorAll('.friend-list > li').forEach(function (element) {
        element.classList.remove('active');
      });
    }
    console.log("ici")

    document.getElementById('messages').innerHTML = "";

    dispatch(chat({ receiver_id, annee, client: client.replace("/", "") })).then((msg) => {
      if (msg.payload) {
        var payload = msg.payload;

        for (var i = 0; i < payload.length; i++) {
          var direction = 'left';
          payload[i].roles = payload[i].senders.roles;

          if (payload[i].sender_id != receiver_id) {
            direction = 'right';
          }

          var member = messageElement(payload[i], direction);
          document.getElementById('messages').appendChild(member);
        }

        var conv = payload.length > 0 ? payload[0].conversation_id : generateMessageUniqueIdentifier();

        if (clearActive) {
          if (lastActiveClass && document.getElementById(lastActiveClass)) {
            document.getElementById(lastActiveClass).classList.remove("active");
          }
          if (document.getElementById("oneMem" + receiver_id)) {
            document.getElementById("oneMem" + receiver_id).classList.add("active");
            setLastActiveClass("oneMem" + receiver_id);
          }
        }

        document.getElementById('m').style.display = 'block';
        initiateSockets(conv, receiver_id);

        var messagesContainer = document.getElementById('messages');
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
      }
    });
  };

  return (
    <div className="messagerie-style">
      <Card>
        <Card.Body>
          <div className="container bootstrap snippet">
            <div className="row">
              <div className="col-md-4 bg-white">
                <Card.Header>
                  <Card.Title as="h4">{t("Recent")}</Card.Title><br />
                  {obj.user.id_role == 5 || obj.user.id_role == 10 ? (
                    <Row>
                      <Col className="pl-1" md="12">
                        <Form.Group id="roleClass">
                          <label>{t("grossiste")} </label>
                          <Select
                            placeholder={t("grossiste")}
                            className="react-select primary"
                            classNamePrefix="react-select"
                            value={grossisteSelect}
                            onChange={(value) => {
                              setGrossisteSelect(value);
                              loadMyMessages(annee, value.value, client);
                            }}
                            options={options}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  ) : null}
                </Card.Header>
                <ul className="friend-list" id="member_area"></ul>
              </div>
              <div className="col-md-7 bg-white ml-3">
                <div className="chat-message">
                  <ul className="chat" id="messages" style={{ height: "75vh", overflowY: "scroll" }}></ul>
                </div>
                <div className="chat-box bg-white">
                  <div className="input-group">
                    <input
                      onKeyPress={(e) => createMessage(e)}
                      style={{ border: "none", boxShadow: "none", borderRadius: "none" }}
                      className="form-control input-msg no-shadow no-rounded"
                      id="m"
                      placeholder="Écrivez votre message..."
                    />
                    <span className="input-group-btn">
                      <button style={{ display: "none" }} id="sub" className="btn btn-success no-rounded" type="button">
                        Send
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default Messagerie;
